import React from 'react';
import axios from 'axios';
import { useEffect,useState } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function EquipeArbitrage() {
    const [equipe, setEquipe] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;



  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}/recherche/equipe-arbitre`,
          {
            type : 'equipe'
          },
          {
            withCredentials: true 
          }
        );
        setEquipe(response.data);
        setError(null);
        setIsLoading(false);

      } catch (error) {
        if (error.response) {   
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
        setIsLoading(false);

      }
    };

    fetchData(); 
  }, [apiUrl]);
  
        if (isLoading) {
          return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }
        if(error){
            return (
                <>
                <div id="alert-message" className="alert4" >
                    <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                </div>
              </>  
            )
        }


  return (
    <>
    {equipe && 
        <>
          <Card className="bg-dark text-white" style={{borderRadius: "var(--bs-card-border-radius)"}}>
            <Card.Img src="/img/teamArbitrage.jpg" alt="Card image" />
            <Card.ImgOverlay>
              <div className="text-center mb-3">
                <Card.Title><strong>Proposez d'arbitrer un match : équipes.</strong></Card.Title>
              </div>
            </Card.ImgOverlay>
          </Card>
          <br/>
          <Row xs={1} md={2} className="g-4">
            {equipe && equipe.equipe.map((item, index) => (
                <Col key={index}>
                    <Card className="card_arbitre" >
                        <div className="row">

                            <div className="col-md-8" style={{width:"100%"}}>
                                <Card.Body>
                                      <div className="text-center mb-3">
                                          <Card.Title>{item.nom}</Card.Title> 
                                      </div>    
                                      <Card.Text>
                                          <strong>Adresse :</strong> {item.adresse} <br/>
                                          <strong>Catégorie :</strong> {item.categorie} <br/>
                                          <strong>Coach : </strong>
                                          {item.coaches && item.coaches.split(', ').map((coach, index) => (
                                              <React.Fragment key={index}>
                                                  {coach} {index !== item.coaches.split(', ').length - 1 && ','}
                                              </React.Fragment>
                                          ))} <br/>
                                      </Card.Text>
                                    <div className="text-center mb-3">
                                      <Link to={`/arbitre/tableau-de-bord/arbitrage/${item.nom}/${item.id_equipe}`}>
                                        <Button className="custom-btn" variant="primary" >Voir les matchs disponible</Button>
                                      </Link>  
                                  </div>
                                </Card.Body>
                            </div>
                        </div>
                    </Card>
                </Col>
            ))}
        </Row>
        <br/>
        </>
    }


    </>
  );
}

export default EquipeArbitrage;